<template>
    <svg width="100%" height="100%" viewBox="0 0 200 200" fill="none">
        <path d="M38.6781 72.3437C35.3969 50.9375 66.1781 44.5313 71.1781 66.25L79.6156 108.125H111.022C120.084 108.125 124.928 115.469 124.928 122.187V179.062C124.928 192.969 105.241 192.812 105.241 178.75V134.687H65.0844C55.7094 134.687 49.9281 128.281 48.5219 120.937L38.6781 72.3437Z" :fill="color"/>
        <path d="M53.3656 47.3437C63.5219 47.3437 71.8031 39.2187 71.9594 28.9062C71.9594 18.75 63.6781 10.4688 53.3656 10.4688C43.2094 10.4688 34.9281 18.5937 34.9281 28.75C34.9281 39.0625 43.0531 47.3437 53.3656 47.3437Z" :fill="color"/>
        <path d="M13.2094 94.6875C11.0219 82.8125 26.6469 80 28.8344 91.875L35.7094 129.219C37.2719 137.031 42.8969 143.594 51.0219 146.094C53.5219 146.875 56.1781 146.875 58.5219 147.031L81.1781 147.187C93.2094 147.187 93.2094 162.969 81.0219 162.969L57.2719 162.812C53.6781 162.812 49.9281 162.344 46.3344 161.25C32.2719 157.031 22.4281 145.469 19.9281 132.031L13.2094 94.6875Z" :fill="color"/>
        <path d="M145.5 21.1111V32.5H152.333M166 32.5C166 43.8219 156.822 53 145.5 53C134.178 53 125 43.8219 125 32.5C125 21.1782 134.178 12 145.5 12C156.822 12 166 21.1782 166 32.5Z" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            default: "#3b3b3b",
            type: String
        }
    }
}
</script>